<template>
  <section class="main-section" v-if="$store.state.department">
    <div class="main-section__container">
      <div class="main-section__column">
        <h1 class="main-section__header">{{ $store.state.department.title }}</h1>
        <router-link :to="{ name: 'apply' }" class="button">
          <span class="button__text">Обращение к руководителю</span>
          <i class="button__icon" aria-hidden="true">
            <arrow-icon/>
          </i>
        </router-link>
      </div>
      <div class="main-section__column">
        <img class="main-section__image" :src="$store.state.api + $store.state.department.img_head" :alt="$store.state.department.title"/>
      </div>
    </div>
  </section>
</template>

<script>
import ArrowIcon from 'components/svg/ArrowIcon.vue'

export default {
  name: 'MainSection',
  components: { ArrowIcon }
}
</script>
